// extracted by extract-css-chunks-webpack-plugin
module.exports = {"topicTitleSmall":"topicTitleSmall-IZboW6on","title_logo":"title_logo-6xRgasfS","title":"title-3S8z36OP"};